export const UPDATE_LOGS_REQUEST = "logs/UPDATE_LOGS_REQUEST";
export const UPDATE_LOGS_SUCCESS = "logs/UPDATE_LOGS_SUCCESS";
export const UPDATE_LOGS_FAILURE = "logs/UPDATE_LOGS_FAILURE";

export const GET_LOGS_REQUEST = "logs/GET_LOGS_REQUEST";
export const GET_LOGS_SUCCESS = "logs/GET_LOGS_SUCCESS";
export const GET_LOGS_FAILURE = "logs/GET_LOGS_FAILURE";
